import { Box } from '@mui/system'
import { PlanLabel, PlanTileType } from '../types'
import { PlanTileCopy } from './PlanTileCopy'
import { PlanTileImage } from './PlanTileImage'
import { Spacer } from '@dtx-company/shared-components/src/components/atoms/Spacer/index'
import Link from 'next/link'
import React from 'react'
import events from '@dtx-company/inter-app/src/event-tracking/events/nav'

export const PlanTile: React.FC<PlanTileType> = ({
  planName,
  href,
  header,
  subheader,
  planImageSrc
}) => {
  const [isHovered, setIsHovered] = React.useState(false)
  const isCompare = planName === PlanLabel.COMPARE || planName === PlanLabel.NEXT_PLAN
  return (
    <Link href={href} target="_blank" data-testid="upgrade-plan-tile">
      <Box
        data-testid="upgrade-plan-tile"
        width="100%"
        onClick={() =>
          events.Platform_PlansUpgradeDialog_Clicked_PlanTile(
            planName === PlanLabel.COMPARE ? 'Compare All Plans' : planName
          )
        }
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'row', sm: isCompare ? 'row' : 'column', md: 'row', lg: 'column' },
            cursor: 'pointer',
            height: 'auto'
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <PlanTileImage
            hovered={isHovered}
            planImageSrc={planImageSrc}
            planName={planName}
            isCompare={isCompare}
          />
          <Spacer mb="16px" mr="16px" />
          <PlanTileCopy header={header} subheader={subheader} />
        </Box>
      </Box>
    </Link>
  )
}
